// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BanOutlinedSvg from "@fishx/icons-svg/es/asn/BanOutlined";
import FishxIcon from '../components/FishxIcon';

var BanOutlined = function BanOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BanOutlinedSvg
  }));
};

BanOutlined.displayName = 'BanOutlined';
export default React.forwardRef(BanOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BanOutlined.js
// module id = 2050
// module chunks = 0